import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsPedidosClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getPedidos(queries = {}) {
    try {
      return await this.api.get('/pedidos', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Pic-item ');
    }
  }

  async postPedidos(data) {
    try {
      return await this.api.post('/pedidos', data);
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Pic-item ');
    }
  }

  async getPedidoById(id) {
    try {
      const { data } = await this.api.get(`/pedidos/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Pic-item ');
    }
  }

  async createPedidoOperacao(data) {
    try {
      return await this.api.post('pedidos/salvarPedidoOperacao', data);
    } catch (error) {
      throw error;
    }
  }

  async salvarPedidoTotvs(data) {
    try {
      return await this.api.post('pedidos/salvarPedidoTotvs', data);
    } catch (error) {
      throw error;
    }
  }

  async createRascunhoOperacao(data) {
    try {
      return await this.api.post('pedidos/salvarRascunhoOperacao', data);
    } catch (error) {
      throw error;
    }
  }

  async putPedidosById(id, data) {
    try {
      const { data: response } = await this.api.put(`/pedidos/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Pic-item ');
    }
  }

  async deletePedidosById(id) {
    try {
      const { data: response } = await this.api.delete(`/pedidos/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar pedido');
    }
  }

  async postPedidosSalvarPedidoCarrinho(data) {
    try {
      return await this.api.post('/pedidos/salvarPedidoCarrinho', data);
    } catch (error) {
      throw this.error.messageCustom(error, 'Erro ao finalizar o pedido');
    }
  }

  async postPedidosSalvarRascunhoCarrinho(data) {
    try {
      return await this.api.post('/pedidos/salvarRascunhoCarrinho', data);
    } catch (error) {
      throw this.error.messageCustom(error, 'Erro ao finalizar o rascunho');
    }
  }

  async updatePedidoHeader(id, data) {
    try {
      return await this.api.put(`/pedidos/${id}/atualizar-pedido`, data);
    } catch (error) {
      throw this.error.messageCustom(error, 'Erro ao atualizar dados do pedido');
    }
  }
}
